
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elections/2022/races/embed/graph/cumulative-chart-president",
      function () {
        return require("private-next-pages/elections/2022/races/embed/graph/cumulative-chart-president.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elections/2022/races/embed/graph/cumulative-chart-president"])
      });
    }
  